import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import { NotificationProvider } from 'Common/Components/Notifications/NotificationProvider';
import MessageProvider from 'Common/Components/Messages/MessageProvider';
import { OverlayProvider } from 'Common/Components/LoadingOverlay/OverlayContext';
import { TranslationProvider } from 'Common/Components/Translation/TranslationContextType ';
import { I18nextProvider } from 'react-i18next';
import i18n from 'Common/Components/Translation/i18n'
import { CurrencyProvider } from 'Common/Components/Currency/CurrencyContext';
import { AuthenticationProvider } from 'Common/Components/Authentication/AuthenticationProvider';
import { CartProvider } from 'Common/Components/Cart/CartContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthenticationProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <I18nextProvider i18n={i18n}>
            <TranslationProvider>
              <MessageProvider>
                <NotificationProvider>
                  <CartProvider>
                    <CurrencyProvider>
                      <OverlayProvider>
                        <App />
                      </OverlayProvider>
                    </CurrencyProvider>
                  </CartProvider>
                </NotificationProvider>
              </MessageProvider>
            </TranslationProvider>
          </I18nextProvider>
        </BrowserRouter>
      </AuthenticationProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
